// Beispiel: src/api/auth.js
import axios from "axios";
import { getApiBaseUrl } from "./config";
import { CapacitorHttp } from '@capacitor/core';
import { Capacitor } from '@capacitor/core';

// Use native HTTP for mobile apps to avoid CORS issues
const nativeHttp = async (method, url, data = null, headers = {}) => {
  if (Capacitor.isNativePlatform()) {
    console.log('Using native HTTP:', method, url);
    console.log('Request data:', JSON.stringify(data));

    const options = {
      url,
      method,
      headers: {
        'Content-Type': 'application/json',
        ...headers
      },
    };

    if (data) {
      // CapacitorHttp needs the data as a JSON string for Android
      options.data = typeof data === 'string' ? data : JSON.stringify(data);
    }

    console.log('Full request:', JSON.stringify(options));

    try {
      const response = await CapacitorHttp.request(options);
      console.log('Raw response received:', JSON.stringify(response));
      console.log('Response status:', response.status);
      console.log('Response data type:', typeof response.data);
      console.log('Response data:', JSON.stringify(response.data));

      // Check if response.data is a string (needs parsing)
      let responseData = response.data;
      if (typeof responseData === 'string') {
        console.log('Response data is string, parsing...');
        try {
          responseData = JSON.parse(responseData);
          console.log('Parsed response data:', JSON.stringify(responseData));
        } catch (parseError) {
          console.error('Failed to parse response data:', parseError);
          throw new Error('Invalid JSON response from server');
        }
      }

      // Check for error status codes
      if (response.status >= 400) {
        console.error('HTTP error status:', response.status);
        throw {
          response: {
            status: response.status,
            data: responseData
          },
          message: `HTTP ${response.status}`
        };
      }

      return responseData;
    } catch (error) {
      console.error('CapacitorHttp request failed:', error);
      console.error('Error type:', typeof error);
      console.error('Error keys:', Object.keys(error || {}));
      console.error('Error message:', error.message);
      console.error('Error status:', error.status);

      // Re-throw with better error structure
      throw {
        message: error.message || 'Network request failed',
        response: error.response || {
          status: error.status || 0,
          data: error.data || null
        }
      };
    }
  } else {
    // Use axios for web
    console.log('Using axios HTTP:', method, url);
    const response = method === 'POST'
      ? await axios.post(url, data, { headers })
      : await axios.get(url, { headers });
    return response.data;
  }
};

export const login = async (credentials) => {
  // Load API URL from preferences (async)
  const API_BASE_URL = await getApiBaseUrl();
  console.log('Login: Using API URL:', API_BASE_URL);
  console.log('Platform:', Capacitor.getPlatform(), 'Native:', Capacitor.isNativePlatform());

  const data = await nativeHttp('POST', `${API_BASE_URL}/auth/token/`, credentials);
  return data;
};

export const refreshAccessToken = async (refreshToken) => {
  const API_BASE_URL = await getApiBaseUrl();
  const data = await nativeHttp('POST', `${API_BASE_URL}/auth/refresh/`, {
    refresh: refreshToken,
  });
  return data;
};